import { getVisibilityColumns } from '@components/ColumnsVisibilityToggle/getVisibilityColumns';

import { columns } from './columns';

const operationsVisibilityColumns = getVisibilityColumns(columns);

export { operationsVisibilityColumns };
